export const heroText = {
  hey: ["Hey,", "my name is"],
  name: "Segev Grotas",
  title: "And I am a DevOps Engineer!",
  paragraphs: [
    "B.Sc. in Information Systems (Graduated with Honors) | Graduate of Develeap's DevOps Program.",
    "Skilled in Jenkins pipelines, Docker containerization, Terraform (IaC), and cloud environments (AWS).",
    "Passionate about building reliable infrastructure and reducing deployment effort through automation.",
    "2 years of software development background — bringing a developer's mindset to every infrastructure challenge.",
  ],
  buttons: { CV: "Download CV", Certificate: "Certificate of Excellence" },
};
